import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from "@angular/core";
import { Role } from "../../../../../../models/role";
import { RoleInstitution } from "../../../../../../models/role-institution";
import { RoleInstitutionControllerService } from "../../../../../../services/role-controller/role-institution-controller.service";
import { ActivatedRoute } from "@angular/router";
import { Store } from "../../../../../../services/store.service";
import { TranslatedBaseError } from "../../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { UnitService } from "../../../../../../services/unit-controller/unit.service";
import { RecoverOrphanConfig } from "../../../../../../models/recover-orphan-config";

@Component({
  selector: "determinant-institution",
  templateUrl: "./determinant-institution.component.html",
  styleUrls: ["./determinant-institution.component.scss"],
})
export class DeterminantInstitutionComponent extends TranslatedBaseError implements OnInit {

  @Input() public role: Role;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public roleInstitutions: RoleInstitution[];
  @Input() public debugErrors: RecoverOrphanConfig[] = [];

  @Output() public selectInstitution = new EventEmitter();

  public roleId: any;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private roleInstitutionControllerService: RoleInstitutionControllerService,
    toastr: ToastrService, public translateService: TranslateService,
    private unitService: UnitService,
  ) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.roleId = params.roleId;
    });
  }

  public hasDeterminant(item) {
    if (!item.jsonDeterminants || item.jsonDeterminants === '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public hasError(itemId: string): boolean {
    if (!this.debugErrors || !this.debugErrors.length || !itemId) { return false; }
    return this.debugErrors.some(error => itemId.includes(error.conflictingValue));
  }

  public removeDeterminant(item) {
    item.jsonDeterminants = "";
    item.showDeterminants = false;
    this.saveInstitution(item);
  }

  public saveInstitution(inst) {
    if (inst && this.roleId) {
      const saveMethod = inst.id ?
        this.roleInstitutionControllerService.saveRoleInstitution(inst.id, inst)
        : this.roleInstitutionControllerService.createRoleInstitution(this.roleId, inst);
      saveMethod.subscribe(
        () => { this.responseSuccessful("Data is saved!"); },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
      );
    }
  }

  public openDetEdit(e) {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "institution-determinant";
    this.selectInstitution.emit(e);
  }
}
